import React, { useState } from "react";
import PrimaryHeading from '../../../components/common/primaryHeading';
import ButtonWithSearch from '../../../components/common/buttonWithSearch';
import InputPrimaryComponents from '../../../components/common/inputPrimaryComponents';
import AddButtonSection from '../../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { commonPostApi } from "../../../utils/apiService";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import { showToast } from '../../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../../constants/toast";

const NewTemplate = () => {
    const { control, errors, handleSubmit } = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const templateButtons = [
        {
            type: "primarySuccessButton",
            label: "Add Template",
            class: "pl-3",
            disabled: loading,
            onClick: handleSubmit(async (data) => {
                if (loading) return;
                setLoading(true);
                try {
                    if (!data?.templateName || !data?.title || !data?.description) {
                        showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.REQUIRED_FIELDS);
                        setLoading(false);
                        return;
                    }
                    const payload = {
                        notification_title: data?.title,
                        notification_description: data?.description,
                        template_name: data?.templateName,
                    };
                    const res = await commonPostApi(API_ENDPOINTS.ADD_NOTIFICATION_TEMPLATE, payload);
                    if (res?.status === 200 || res?.status === 201) {
                        setLoading(false);
                        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.NOTIFICATION.TEMPLATE_CREATED);
                        setTimeout(() => {
                            navigate('/notifications/manage');
                        }, 800);
                        return;
                    }
                    showToast(TOAST_TYPE.ERROR, res?.data?.message || COMMON_MSG.ERROR.GENERIC);
                    setLoading(false);
                } catch (error) {
                    console.error('Error creating template:', error);
                    const errMsg = error?.response?.data?.message || COMMON_MSG.ERROR.GENERIC;
                    showToast(TOAST_TYPE.ERROR, errMsg);
                    setLoading(false);
                }
            }),
        },
        {
            type: "secondaryButton",
            label: "Discard",
            class: "pl-3 col-",
            disabled: loading,
            onClick: () => {
                navigate('/notifications/manage');
            },
        },
    ];

    return (
        <div className="container mt-3 mb-3">
            <PrimaryHeading className={"mt-5 mb-3"} />
            <div style={{ color: "rgba(47, 43, 61, 0.9)" }}>
                <ButtonWithSearch
                    searchHeaderLable={"Add New Template"}
                />
            </div>
            <form className="mt-4">
                <div className="md:row md:flex md:gap-4" >
                    <div className="md:col" style={{ flex: 1 }}>
                        <div>
                            <InputPrimaryComponents
                                control={control}
                                errors={errors}
                                type="text"
                                name="templateName"
                                label="Template Name"
                                placeholder="Enter the Template Name"
                                required
                            />
                        </div>

                        <div className=" ">
                            <InputPrimaryComponents
                                control={control}
                                errors={errors}
                                type="text"
                                name="description"
                                label="Description"
                                placeholder="Enter the Description"
                                className="mb-4"
                                required
                            />
                        </div>
                    </div>
                    <div className=" md:col">
                        <InputPrimaryComponents
                            control={control}
                            errors={errors}
                            type="text"
                            name="title"
                            label="Title"
                            placeholder="Enter the Title"
                            required
                        />
                    </div>
                </div>
            </form>
            <div className="mt-5">
                <AddButtonSection buttons={templateButtons} />
            </div>
        </div>
    );
};

export default NewTemplate; 